import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, Show, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import './Renderer_PathwayTransitions.scss';
import { arrayIncludesAny, asArray, dbObjectToId, exists, sortArray } from '@nu-art/ts-common';
import { Renderer_PathwayActions } from '../Renderer_PathwayActions/Renderer_PathwayActions.js';
import { Renderer_PathwayResolution } from '../Renderer_PathwayResolution/Renderer_PathwayResolution.js';
import { ModuleFE_PathwayTransition } from "../../../../../../_entity/pathway-transition/ModuleFE_PathwayTransition.js";
import { guardResolutionAccordionUnsaved } from '../resolution-accordion-guard.js';
import { Renderer_TransitionLabelEditor } from './Renderer_TransitionLabelEditor.js';
export class Renderer_PathwayTransitions extends ComponentSync {
    // ######################## Life Cycle ########################
    __onPathwayTransitionUpdated = (...params) => {
        const changedTransitionIds = asArray(params[1]).map(dbObjectToId);
        const currentTransitionIds = this.state.transitions.map(dbObjectToId);
        if (arrayIncludesAny(changedTransitionIds, currentTransitionIds))
            this.reDeriveState();
    };
    deriveStateFromProps(nextProps, state) {
        state.stateId = nextProps.stateId;
        state.transitions = ModuleFE_PathwayTransition.cache.filter(t => {
            if (!t.pathwayIds.includes(nextProps.pathwayId))
                return false;
            return !!state.stateId ? t.sourceId === state.stateId : true;
        });
        return state;
    }
    // ######################## Render ########################
    render() {
        const transitions = this.state.transitions;
        if (exists(this.props.stateId))
            sortArray(transitions, t => t.priorityIndex);
        // Ticket #10157 point 6.a — in state view (stateId present), render transitions as a flat list
        // (no outer accordion, no "X Transitions" header) to match the old `Section_StateTransitions`.
        // Pathway-level view (no stateId) keeps the accordion.
        if (exists(this.props.stateId))
            return _jsx(LL_V_L, { className: 'pathway-transitions--flat', children: transitions.map(this.render_Transition) });
        return _jsx(TS_CollapsableContainerV2, { className: 'pathway-transitions', headerRenderer: () => `${transitions.length} Transitions`, containerRenderer: () => _jsx(LL_V_L, { children: transitions.map(this.render_Transition) }), animated: true, forceUpdate: true });
    }
    render_Transition = (transition) => {
        return _jsxs(LL_V_L, { className: 'pathway-transition', children: [_jsxs(LL_H_C, { className: 'pathway-transition__header', children: [exists(this.state.stateId) &&
                            _jsx("div", { className: 'pathway-transition__priority', children: transition.priorityIndex }), exists(this.state.stateId) && this.props.editMode
                            ? _jsx(Renderer_TransitionLabelEditor, { transitionId: transition._id })
                            : _jsx(Button, { variant: 'text', onClick: async () => {
                                    if (!(await guardResolutionAccordionUnsaved(this.props.tabId)))
                                        return;
                                    this.props.workHubItem.updateArgs(this.props.tabId, { stateId: undefined, transitionId: transition._id });
                                }, children: transition.label })] }), _jsx(Show.If, { condition: exists(transition.resolutionFunctionId), children: _jsx(Renderer_PathwayResolution, { transitionId: transition._id }) }), _jsx(Renderer_PathwayActions, { pathwayId: this.props.pathwayId, transitionId: transition._id })] }, transition._id);
    };
}
//# sourceMappingURL=Renderer_PathwayTransitions.js.map